/* eslint-disable @typescript-eslint/naming-convention */
import parsePhoneNumberFromString from 'libphonenumber-js';
import * as Yup from 'yup';

import { isValidEmail, isValidName } from '../../../../../Utils/validation';

export const collectorCreateUserValidationSchema = (): any => {
  return Yup.object().shape({
    profile_img: Yup.string(),
    first_name: Yup.string()
      .required('First name is required')
      .test('test-name', 'Enter Valid First Name', (value) => !value || isValidName(value)),
    middle_name: Yup.string().test('test-name', 'Enter Valid Middle Name', (value) => !value || isValidName(value)),
    last_name: Yup.string()
      .required('Last name is required')
      .test('test-name', 'Enter Valid Last Name', (value) => !value || isValidName(value)),
    email: Yup.string()
      .required('Email is required')
      .test('test-name', 'Enter Valid Email', (value) => !!value && isValidEmail(value)),
    phone_number: Yup.string()
      .required('Phone number is required')
      .test('valid-us-phone', 'Enter Valid Phone Number', (value) => {
        if (!value) return false;
        const phoneNumber = parsePhoneNumberFromString(value, 'US');
        return phoneNumber?.isValid() ?? false;
      }),
    client_tags: Yup.array().min(1, 'Select at least one client tag').required('Select at least one client tag'),
  });
};
